<div class="auth-shell">
  <!-- LEFT: Brand panel (static — presentational only) -->
  <div class="auth-brand">
    <div class="auth-brand__deco"></div>

    <div class="auth-brand__logo-row">
      <div class="auth-brand__logo-box">
        <img [src]="logoUrl" alt="Product Logo" class="auth-brand__logo-img" />
      </div>
    </div>

    <div class="auth-brand__copy">
      <h1 class="auth-brand__headline">Welcome back</h1>
      <p class="auth-brand__sub">Sign in to manage clients, transactions and settings from one place.</p>

      <ul class="auth-brand__features">
        <li class="auth-brand__feature"><span class="auth-brand__feature-icon">👥</span><span>Client &amp; offer management</span></li>
        <li class="auth-brand__feature"><span class="auth-brand__feature-icon">💳</span><span>Transactions at a glance</span></li>
        <li class="auth-brand__feature"><span class="auth-brand__feature-icon">📊</span><span>Reports &amp; usage insights</span></li>
      </ul>
    </div>

    <footer class="auth-brand__footer">&copy; {{ currentYear }} Admin Console</footer>
  </div>

  <!-- RIGHT: Form panel — same form, fields, ids and submit() handler as before -->
  <div class="auth-form-panel">
    <div class="auth-form-wrap">
      <h2 class="auth-form-title">Admin Login</h2>
      <p class="auth-form-sub">Enter your credentials to continue</p>

      <div class="alert alert-warning" role="alert" *ngIf="sessionExpired">
        Your session has expired. Please sign in again.
      </div>

      <form [formGroup]="form">
        <div class="form-group">
          <label for="email">Email</label>
          <input formControlName="email" id="email" type="email" class="form-control" placeholder="example@domain.com" />
          <div *ngIf="f['email'].touched && f['email'].invalid" class="error">
            <div *ngIf="f['email'].errors && f['email'].errors['required']" class="error">
              Email is required.
            </div>
            <div *ngIf="f['email'].errors && f['email'].errors['email']" class="error">
              Please, enter valid email address.
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="pass">Password</label>
          <input formControlName="pass" id="pass" type="password" class="form-control"
            placeholder="Enter your Password" />
          <div *ngIf="f['pass'].touched && f['pass'].invalid" class="error">
            <div *ngIf="f['pass'].errors && f['pass'].errors['required']" class="error">
              Password is required
            </div>
            <div *ngIf="f['pass'].errors && f['pass'].errors['minlength']" class="error">
              Password should be 6 character.
            </div>
          </div>
        </div>

        <div class="form-group">
          <button class="btn btn-primary submit" [disabled]="form.invalid" type="submit" (click)="submit()">
            Sign in
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
